import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';

export interface UsageBarLegendRowProps {
    displayName: string;
    legendIndex: number;
}
const styles = require('./UsageBarLegendRow.scss');
const classNames = require('classnames/bind').bind(styles);

export default function UsageBarLegendRow(props: UsageBarLegendRowProps) {
    return (
        <div className={classNames(styles.legendContainer, getLegendRowStyle(props.legendIndex))}>
            <Icon className={styles.dotIcon} iconName={'LocationDot'} />
            <span className={styles.legendText}>{props.displayName}</span>
        </div>
    );
}

function getLegendRowStyle(legendIndex: number) {
    switch (legendIndex) {
        case 0:
            return styles.dot1;
        case 1:
            return styles.dot2;
        case 2:
            return styles.dot3;
        case 3:
            return styles.dot4;
    }
}
